import React, { useEffect } from "react";
import styled from "styled-components";

import useState from "../../../Hooks/useState";
import { resize } from "../../../Utils/constants";
import useKeyPress from "../../../Hooks/useKeyPress";
import { ClipLoader } from "react-spinners";
import Theme from "../../../Styles/Theme";
import { LeftArrowIcon, PinArrowIcon } from "../../Common/Icons";
import { useHistory } from "react-router-dom";

const BackHeader = styled.div`
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0px 15px;
`;

const PageVIew = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const NumberPad = styled.div`
  background-color: #f0f4fa;
  width: 25vw;
  height: 25vw;
  border-radius: 25vw;
  display: flex;
  margin-right: 10px;
  justify-content: center;
  align-items: center;

  max-width: 150px;
  max-height: 150px;
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

const DisabledNumberPad = styled.div`
  display: flex;
  background-color: #f0f4fa;
  width: 25vw;
  height: 25vw;

  max-width: 150px;
  max-height: 150px;
  border-radius: 25vw;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
`;

const InvisibleNumberPad = styled.div`
  width: 25vw;
  height: 25vw;
  max-width: 150px;
  max-height: 150px;
  background-color: white;
  margin-right: 10px;
`;

const Number = styled.div`
  color: #899bb3;
  font-size: 2.5em;
  font-weight: 200;
`;

const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 2.5%;
  padding-left: 10px;
`;

const Pin = styled.div`
  letter-spacing: 25px;
  font-family: "roboto-mono";
  margin-left: 25px;
  font-size: 40px;
  font-weight: 100;
  margin-bottom: 25px;
  color: #262626;
  text-align: center;
`;

const PinView = styled.div`
  display: flex;
`;

const ErrorNotification = styled.div`
  font-family: "noto-sans-bold";
  font-size: 13px;
  width: 90%;
  text-align: center;
  height: 20px;
  color: #ff706e;
  margin-bottom: 10px;
`;

const Notification = styled.div`
  font-family: "noto-sans-thin";
  font-size: 16px;
  margin-bottom: 2.5%;
  width: 80%;
  text-align: center;
`;

const numberSplit = (number) => {
  const spacing = `______`;

  if (!number) {
    return spacing;
  }

  const cnt = number.length;
  const splited = spacing.substring(0, 6 - cnt);
  const numberSpacing = number + splited;

  let star = "";
  for (let i = 0; i < number.length - 1; i++) {
    star += "*";
  }

  const half = numberSpacing.substring(number.length - 1, 6);

  return star + half;
};

const Pad = ({ number, isTouched, pin }) => {
  if (number === null) {
    return <InvisibleNumberPad />;
  }

  if (number === "delete") {
    return (
      <NumberPad
        style={{ backgroundColor: isTouched.state === number ? Theme.mainColor : "#f0f4fa" }}
        onClick={() => {
          if (pin.state.length > 0) {
            pin.setState(pin.state.substring(0, pin.state.length - 1));
          }
        }}
      >
        <PinArrowIcon size={30} color="#899bb3" />
      </NumberPad>
    );
  }

  return pin.state.length < 6 ? (
    <NumberPad
      style={{ backgroundColor: isTouched.state === number ? Theme.mainColor : "#f0f4fa" }}
      onClick={() => {
        if (pin.state.length < 6) {
          pin.setState(pin.state + number);
        }
      }}
    >
      <div>
        <Number>{number}</Number>
      </div>
    </NumberPad>
  ) : (
    <DisabledNumberPad>
      <Number>{number}</Number>
    </DisabledNumberPad>
  );
};

const Container = ({ pin, title, error = null, isLoading = false, goBack = () => null }) => {
  const isTouched = useState(null);
  const numberList = useState([]);
  const press_0 = useKeyPress("0");
  const press_1 = useKeyPress("1");
  const press_2 = useKeyPress("2");
  const press_3 = useKeyPress("3");
  const press_4 = useKeyPress("4");
  const press_5 = useKeyPress("5");
  const press_6 = useKeyPress("6");
  const press_7 = useKeyPress("7");
  const press_8 = useKeyPress("8");
  const press_9 = useKeyPress("9");

  useEffect(() => {
    if (pin.state.length < 6) {
      if (press_0) {
        pin.setState(pin.state + "0");
        return;
      }
      if (press_1) {
        pin.setState(pin.state + "1");
        return;
      }
      if (press_2) {
        pin.setState(pin.state + "2");
        return;
      }
      if (press_3) {
        pin.setState(pin.state + "3");
        return;
      }
      if (press_4) {
        pin.setState(pin.state + "4");
        return;
      }
      if (press_5) {
        pin.setState(pin.state + "5");
        return;
      }
      if (press_6) {
        pin.setState(pin.state + "6");
        return;
      }
      if (press_7) {
        pin.setState(pin.state + "7");
        return;
      }
      if (press_8) {
        pin.setState(pin.state + "8");
        return;
      }
      if (press_9) {
        pin.setState(pin.state + "9");
        return;
      }
    }
  }, [press_0, press_1, press_2, press_3, press_4, press_5, press_6, press_7, press_8, press_9]);

  useEffect(() => {
    const numbers = [];
    let cnt = 0;
    while (cnt < 10) {
      const rand = Math.floor(Math.random() * 10);
      const isDuplicated = numbers.some((item) => {
        return item === rand;
      });
      if (!isDuplicated) {
        numbers.push(rand);
        cnt++;
      }
    }
    numberList.setState(numbers);
  }, []);

  return (
    numberList.state.length > 9 && (
      <PageVIew>
        <BackHeader>
          <div onClick={goBack}>
            <LeftArrowIcon size={20} color={Theme.darkGrey} />
          </div>
        </BackHeader>
        <ErrorNotification>{error}</ErrorNotification>
        <Notification>{title}</Notification>
        {isLoading ? (
          <PinView
            style={{ marginTop: 35, marginBottom: 20, justifyContent: "center", alignItems: "center", marginLeft: 0 }}
          >
            <ClipLoader size={15} color={Theme.darkGrey} />
          </PinView>
        ) : (
          <Pin>{numberSplit(pin.state)}</Pin>
        )}
        <Line>
          <Pad number={numberList.state[0]} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[1]} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[2]} isTouched={isTouched} pin={pin} />
        </Line>
        <Line>
          <Pad number={numberList.state[3]} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[4]} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[5]} isTouched={isTouched} pin={pin} />
        </Line>
        <Line>
          <Pad number={numberList.state[6]} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[7]} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[8]} isTouched={isTouched} pin={pin} />
        </Line>
        <Line>
          <Pad number={null} isTouched={isTouched} pin={pin} />
          <Pad number={numberList.state[9]} isTouched={isTouched} pin={pin} />
          <Pad number={`delete`} isTouched={isTouched} pin={pin} />
        </Line>
      </PageVIew>
    )
  );
};

export default Container;
